var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.464,
    height: 13.464,
    viewBox: "0 0 13.464 13.464",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "watch",
    transform: "translate(-621.407 -184.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2313",
    "data-name": "Group 2313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2312",
    "data-name": "Group 2312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M632.9,186.157a6.735,6.735,0,1,0,1.971,4.76A6.692,6.692,0,0,0,632.9,186.157Zm-4.761,10.614a5.854,5.854,0,1,1,5.854-5.854A5.861,5.861,0,0,1,628.139,196.771Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M628.578,186.9H627.7v4.181l2.451,2.789.66-.58-2.232-2.54Z",
    fill: "#6c5b7b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.a000b81ac7f5c81ee542130b129d20fb.svg";
export { ForwardRef as ReactComponent };